<template>
    <general-input
        v-if="shouldShow"
        v-model="kid"
        placeholder="KID"
    />
    <div v-else/>
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import GeneralInput from '@/components/GeneralInput.vue'
import {computed} from 'vue'
import {findSubAccountByUuid} from '@/subaccount/subAccount.service'

const line = defineModel<TransactionEntryLine>({required: true})

const kid = computed({
    get: () => line.value.kid,
    set: (newValue: string | undefined) => {
        if (!newValue) {
            line.value.kid = undefined
        } else {
            line.value.kid = newValue
        }
    }
})

const isSubAccount = (subAccountUuid: string | undefined) => {
    return subAccountUuid && findSubAccountByUuid(subAccountUuid)
}

const shouldShow = computed(() => {
    return isSubAccount(line.value.creditSubAccount) || isSubAccount(line.value.debitSubAccount)
})

</script>

<style scoped>

</style>